/**
 * Guilloché rosette geometry, shared by the on-screen <Seal> (SVG) and the PDF certificate
 * (jsPDF lines) so both show the exact same engraving.
 * Returns `copies` closed curves, each an array of [x, y] around (cx, cy) with `scale`.
 */
export const rosetteCurves = (level, { cx = 100, cy = 100, scale = 1, steps = 260 } = {}) => {
  const copies = 3 + level * 2;
  const lobes = 5 + level;
  const base = 52;
  const amp = 8 + level * 1.2;
  const curves = [];
  for (let j = 0; j < copies; j += 1) {
    const phase = (j / copies) * (Math.PI / lobes) * 2;
    const pts = [];
    for (let i = 0; i <= steps; i += 1) {
      const a = (i / steps) * Math.PI * 2;
      const r =
        base + amp * Math.sin(lobes * a + phase) * Math.cos((lobes - 1) * a * 0.5 + j * 0.2);
      pts.push([cx + r * scale * Math.cos(a), cy + r * scale * Math.sin(a)]);
    }
    curves.push(pts);
  }
  return curves;
};
